import { Injectable } from "@angular/core";

@Injectable()
export class NgLocalStorage {

    private readonly prefix: string = 'ngStorage-';

    setItem(key: string, value: any) {
        localStorage.setItem(`${this.prefix}${key}`, JSON.stringify(value));
    }

    getItem(key: string) {
        let item = localStorage.getItem(`${this.prefix}${key}`);
        let data = item ? item : null;
        return JSON.parse(data);
    }

    removeItem(key: string) {
        localStorage.removeItem(`${this.prefix}${key}`);
    }

}

@Injectable()
export class NgSessionStorage {

    private readonly prefix: string = 'ngStorage-';

    setItem(key: string, value: any) {
        sessionStorage.setItem(`${this.prefix}${key}`, JSON.stringify(value));
    }

    getItem(key: string) {
        let item = sessionStorage.getItem(`${this.prefix}${key}`);
        let data = item ? item : null;
        return JSON.parse(data);
    }

    removeItem(key: string) {
        sessionStorage.removeItem(`${this.prefix}${key}`);
    }

}